module.exports = __webpack_public_path__ + "static/images/solution.d2f4b18986b21805082a41c2d86a3e84.jpg";